export const TRANSLATION_KEY = {
  // LATE_NIGHT_CALCULATION_METHOD_OPTIONS
  UNIT_RATE: "unit rate",
  ALLOWANCE: "allowance",

  // CONSUMPTION_TAX_OPTIONS
  ROUNDING: "rounding",
  ROUNDING_UP: "rounding up",
  ROUNDING_DOWN: "rounding down",

  // CURRENCY_OPTIONS
  YEN: "Yen",

  // WEIGHT_OPTIONS
  G: "g",
  KG: "kg",

  // METRIK_OPTIONS
  CM: "cm",
  M: "m",

  // EMPLOYMENT_TYPE_OPTIONS
  PERMANENT: "Permanent",
  FEE_CHARGING_EMPLOYMENT_PLACEMENT: "Fee-charging Employment Placement",
  SHORT_TERM: "Short Term",

  // FREQUENCY_WORKING_HOLIDAYS_OPTIONS
  CORPORATE_CALENDAR: "Corporate Calendar",
  DAY_OF_WEEK: "Day of the Week",
  ROTATION: "Rotation",

  // ALLOWANCE_TYPE_OPTIONS
  TRANSPORTATION: "Transportation",
  MEAL: "Meal",
  HOUSING: "Housing",
  HEALTH_CHECKUP: "Health Checkup",
  TRAVEL: "Travel",
  SELF_DEVELOPMENT: "Self-Development",

  // UNIFORM_LOAN_OPTIONS
  FREE: "Free",
  LOAN: "Loan",
  OWN: "Own",

  // HAIR_GROOMING
  HAIR_FREE: "Free",

  // SMOKING_ENVIRONMENT_OPTIONS
  NO_SMOKING_ON_PERMISES: "no smoking on permises",
  INDOOR_SEPARATE_SMOKE_AREA: "indoor separate smoke area",
  OUTDOOR_SEPARATE_SMOKE_AREA: "outdoor separate smoke area",

  // INVOICE_BEGIN_DATE_OPTIONS
  FORTY_HOURS_PER_WEEK: "40 Hours Per Week",
  SIX_DAYS: "6 Days",
  SEVEN_DAYS: "7 Days",

  // WORKFORCE_MANAGEMENT_OPTIONS
  LABOR_MANAGEMENT_AGREEMENT_METHOD: "Labor-Management Agreement Method",
  EQUAL_BALANCED_TREATMENT_METHOD: "Equal and Balanced Treatment Method",

  // CORPORATION_TYPE
  CORPORATION: "Corporation",
  LIMITED_COMPANY: "Limited Company",
  GENERAL_PARTNERSHIP: "General Partnership",
  LIMITED_PARTNERSHIP: "Limited Partnership",
  LLC: "Limited Liability Company (LLC)",
  FOREIGN_COMPANY: "Foreign Company, etc.",
  NATIONAL_GOVERNMENT_AGENCY: "National Government Agency",
  LOCAL_PUBLIC_ENTITY: "Local Public Entity",
  OTHER_INCORPORATED_ENTITY: "Other Incorporated Entity",
  OTHER: "Other",
  OTHER_NEW: "other",
  OTHERS: "Others",

  // PIPELINE_STATUS
  INCREASE_STAFF: "Increase-staff",
  NEGOTIATING: "Negotiating",

  // PIPELINE
  NEW_DEVELOPEMENT: "New-Developement",
  UPSELL: "Upsell",
  CROSS_SELL: "Cross-Sell",

  // GRADE_OPTIONS
  REQUIRING_SUPPORT_1: "Requiring support 1",
  REQUIRING_SUPPORT_2: "Requiring support 2",
  REQUIRING_LONG_TERM_CARE_1: "Requiring long-term care 1",
  REQUIRING_LONG_TERM_CARE_2: "Requiring long-term care 2",
  REQUIRING_LONG_TERM_CARE_3: "Requiring long-term care 3",
  REQUIRING_LONG_TERM_CARE_4: "Requiring long-term care 4",
  REQUIRING_LONG_TERM_CARE_5: "Requiring long-term care 5",

  // REASON_NOT_JOINING_INSURANCE_OPTIONS
  MONTHLY_INCOME_OF_88000_YEN_OR_LESS: "Monthly income of 88,000 yen or less",
  BEING_A_STUDENT: "Being a student",
  WORKING_WITHIN_20_HOURS_PER_WEEK: "Working within 20 hours per week",

  // EMPLOYEMENT_INSURANCE_STATUS_OPTIONS
  RENEWAL: "renewal",

  // PREFERRED_EMPLOYMENT_DURATION_VALUE
  LONG_TERM: "Long Term",

  // BREAK_TIME_OPTIONS
  MINUTES: "Minutes",
  HOUR: "Hour",
  HOURS: "Hours",

  // WAGE_TIME_VALUE
  WEEK: "Week",
  MONTH: "Month",

  // PREFERRED_WORKING_SCHEDULE_OPTIONS
  DAY_SHIFT: "Day Shift",
  NIGHT_SHIFT: "Night Shift",
  ROTATIONAL_SHIFT: "Rotational Shift",
  ROTATIONAL_SHIFT_INCLUDING_MIDNIGHT: "Rotational Shift (including midnight)",
  ROTATIONAL_SHIFT_EXCLUDING_MIDNIGHT: "Rotational Shift (excluding midnight)",

  // POWER_OPTIONS
  POWER_0: "0.0",
  POWER_0_5: "0.5",
  POWER_0_75: "0.75",
  POWER_1: "1.0",
  POWER_1_25: "1.25",
  POWER_1_5: "1.5",
  POWER_1_75: "1.75",
  POWER_2: "2.0",
  POWER_2_25: "2.25",
  POWER_2_5: "2.5",
  POWER_2_75: "2.75",
  POWER_3: "3.0",
  POWER_3_25: "3.25",
  POWER_3_5: "3.5",
  POWER_3_75: "3.75",
  POWER_4: "4.0",

  // MARTIAL_STATUS_OPTIONS
  MARRIED: "married",
  UNMARRIED: "unmarried",
  DIVORCED: "divorced",
  WIDOWED: "widowed",

  // COMMUTING_METHOD_OPTIONS
  CAR: "car",
  BICYCLE: "bicycle",
  MOPED: "moped",
  MOTORCYCLE: "motorcycle",
  WALKING: "walking",
  PUBLIC_TRANSPORTATION: "public transportation",

  // TERM_EMPLOYMENT_OPTIONS
  FIXED: "fixed",
  INDEFINITE: "indefinite",

  // MONTH_DAYS_OPTIONS
  LAST_DAY_OF_MONTH: "Last Day of Month",

  // STAFF STATUS
  TEMPORARY_STAFF: "Temporary Staff",
  WORKING_STAFF: "Working Staff",
  POOL_STAFF: "Pool Staff",

  //COUNTRY
  COUNTRY_JAPAN: "Japan",
  COUNTRY_UK: "United Kingdom",
  COUNTRY_US: "United States",
  COUNTRY_ITALY: "Italy",
  COUNTRY_INDONESIA: "Indonesia",
  COUNTRY_AUSTRALIA: "Australia",
  COUNTRY_CANADA: "Canada",
  COUNTRY_SOUTH_KOREA: "Korea, Republic of South Korea",
  COUNTRY_CHINA: "China",
  COUNTRY_GERMANY: "Germany",
  COUNTRY_NEPAL: "Nepal",
  COUNTRY_PHILIPPINES: "Philippines",
  COUNTRY_FRANCE: "France",
  COUNTRY_BRAZIL: "Brazil",
  COUNTRY_VIETNAM: "Vietnam",
  COUNTRY_PERU: "Peru",
  COUNTRY_MYANMAR: "Myanmar",
  COUNTRY_TAIWAN: "Taiwan",
  COUNTRY_THAILAND: "Thailand",

  //TAG TYPE
  TAG_STAFF: "staff",
  TAG_CORPORATION: "corporation",
  TAG_JOB_LISTING: "joblisting",
  TAG_TICKET: "ticket",

  //RELATIONSHIP
  RELATIONSHIP_FATHER: "father",
  RELATIONSHIP_MOTHER: "mother",
  RELATIONSHIP_GRANDFATHER: "grandfather",
  RELATIONSHIP_GRANDMOTHER: "grandmother",
  RELATIONSHIP_CHILD: "child",
  RELATIONSHIP_GRANDCHILD: "grandchild",
  RELATIONSHIP_FRIEND: "friend",

  //POSIBILITY
  POSSIBILITY_POSSIBLE: "possible",
  POSSIBILITY_NOT_POSSIBLE: "not possible",

  //REJECT JOB TYPES
  REJECT_JOB_TYPES_FOOD_MANUFACTURING: "food manufacturing",
  REJECT_JOB_TYPES_CLEAN_ROOM: "clean room",
  REJECT_JOB_TYPES_ASSEMBLY_LINE_WORK: "assembly line work",
  REJECT_JOB_TYPES_HEAVY_LIFTING: "heavy lifting",
  REJECT_JOB_TYPES_STANDING_WORK: "standing work",
  REJECT_JOB_TYPES_STATIONARY_WORK: "stationary work",
  REJECT_JOB_TYPES_WORK_REQUIRING_GOOD_EYESIGHT: "work requiring good eyesight",
  REJECT_JOB_TYPES_HOT_ENVIRONMENT: "hot environment",
  REJECT_JOB_TYPES_COLD_ENVIRONMENT: "cold environment",
  REJECT_JOB_TYPES_CUSTOMER_SERVICE: "customer service",
  REJECT_JOB_TYPES_CLERICAL_WORK: "clerical work",
  REJECT_JOB_TYPES_NURSING_CARE: "nursing care",
  REJECT_JOB_TYPES_MANUFACTURING: "manufacturing",
  REJECT_JOB_TYPES_LOGISTICS: "logistics",
  REJECT_JOB_TYPES_SALES: "sales",

  //DESIRED JOB TYPES
  DESIRED_JOB_TYPES_CUSTOMER_SERVICE: "customer service",
  DESIRED_JOB_TYPES_CLERICAL_WORK: "clerical work",
  DESIRED_JOB_TYPES_NURSING_CARE: "nursing care",
  DESIRED_JOB_TYPES_COOKING: "cooking",
  DESIRED_JOB_TYPES_FORKLIFT_OPERATION: "forklift operation",
  DESIRED_JOB_TYPES_PICKING: "picking",
  DESIRED_JOB_TYPES_DELIVERY: "delivery",
  DESIRED_JOB_TYPES_MANUFACTURING: "manufacturing",
  DESIRED_JOB_TYPES_LOGISTICS: "logistics",
  DESIRED_JOB_TYPES_FOOD_MANUFACTURING: "food manufacturing",
  DESIRED_JOB_TYPES_SITTING_WORK: "sitting work",

  //PHYSICAL CHARACTERISTICS
  PHYSICAL_CHARACTERISTICS_DYED_HAIR: "dyed hair",
  PHYSICAL_CHARACTERISTICS_SHAVED_HEAD: "shaved head",
  PHYSICAL_CHARACTERISTICS_BEARD: "beard",
  PHYSICAL_CHARACTERISTICS_NAIL_ART: "nail art",
  PHYSICAL_CHARACTERISTICS_NON_REMOVABLE_PIERCINGS: "non-removable piercings",
  PHYSICAL_CHARACTERISTICS_TATTOOS: "tattoos",
  PHYSICAL_CHARACTERISTICS_SIZE_3L_OR_ABOVE: "size 3L or above",

  //JAPANESE LANGUAGE LEVEL
  JAPANESE_LANGUAGE_LEVEL_HIRAGANA: "hiragana",
  JAPANESE_LANGUAGE_LEVEL_KANJI: "kanji",
  JAPANESE_LANGUAGE_LEVEL_KATAKANA: "katakana",

  //HEALTH CONDITION
  HEALTH_CONDITION_NORMAL: "normal",
  HEALTH_CONDITION_HAS_CONDITION: "has condition",

  // STAFF QUALIFICATION
  QUALIFITAION_DRIVERS_LICENSE: "driver's license",
  QUALIFITAION_LARGE_VEHICLE_DRIVERS_LICENSE: "large vehicle driver's license",
  QUALIFITAION_FORKLIFT_CERTIFICATION: "forklift certification",
  QUALIFITAION_SLINGING_CERTIFICATION: "slinging certification",
  QUALIFITAION_CRANE_CERTIFICATION: "crane certification",
  QUALIFITAION_BOOKEEPING_LEVEL_3: "bookeeping level 3",
  QUALIFITAION_BOOKEEPING_LEVEL_2: "bookeeping level 2",
  QUALIFITAION_NURSERY_TEACHER_LICENSE: "nursery teacher license",
  QUALIFITAION_KINDERGARTEN_TEACHER_LICENSE: "kindergarten teacher license",
  QUALIFITAION_COOK_LICENSE: "cook license",
  QUALIFITAION_NUTRITIONIST_LICENSE: "nutritionist license",
  QUALIFITAION_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING:
    "certified care worker beginner training",

  // EMPLOYMENT TYPE
  EMPLOYMENT_TYPE_PERMANENT_EMPLOYEE: "permanent employee",
  EMPLOYMENT_TYPE_CONTRACT_EMPLOYEE: "contract employee",
  EMPLOYMENT_TYPE_PART_TIME: "part-time",
  EMPLOYMENT_TYPE_PART_TIME_ARBEIT: "part-time (arbeit)",
  EMPLOYMENT_TYPE_DISPATCH: "dispatch",
  EMPLOYMENT_TYPE_OUTSOURCE: "outsource",
  EMPLOYMENT_TYPE_SELF_EMPLOYED: "self-employed",

  // STAFF STATUS
  STAFF_STATUS_WORKING_STAFF: "working_staff",
  STAFF_STATUS_POOL_STAFF: "pool_staff",
  STAFF_STATUS_TEMPORARY_STAFF: "temporary_staff",

  // RESIGNATION REASON
  RESIGNATION_REASON_CONTRACT_COMPLETION: "contract completion",
  RESIGNATION_REASON_PERSONAL_REASON: "personal reason",
  RESIGNATION_REASON_POOR_HEALTH: "poor health",
  RESIGNATION_REASON_CAREGIVING: "caregiving",
  RESIGNATION_REASON_MOVING: "moving",
  RESIGNATION_REASON_MARRIAGE: "marriage",
  RESIGNATION_REASON_CHILDBIRTH: "childbirth",
  RESIGNATION_REASON_CAREER_UP: "career up",

  // TYPE OF WORK
  TYPE_OF_WORK_ONSITE: "onsite",
  TYPE_OF_WORK_REMOTE: "remote",
  TYPE_OF_WORK_HYBRID: "hybrid",

  // Field Study
  FIELD_STUDY_NO_PREFERENCE: "no preference",
  FIELD_STUDY_INDUSTRIAL: "industrial",
  FIELD_STUDY_COMMERCE: "commerce",

  //ENROLLED STATUS
  ENROLLED: "enrolled",
  NOT_ENROLLED: "not enrolled",

  // NOT ENROLLED EMPLOYEE REASON
  LESS_THAN_20_HOURS_PER_WEEK: "less than 20 hours per week",
  EXPECTED_LESS_THAN_31_DAYS: "expected less than 31 days employment duration",
  ENROLLED_IN_OTHERS: "enrolled in others",
  LESS_THAN_30_HOURS_PER_WEEK: "less than 30 hours per week",
  MONTHLY_SALARY_UNDER_80K_YEN: "Monthly Salary Under 88,000 Yen",
  EXPECTED_EMPLOYMENT_LESS_THAN_2MONTH:
    "expected employment less than 2 months",
  STUDENT: "student",
  YEARS_70_OR_OLDER: "70 years or older (late-stage elderly)",

  // ENROLLED IN OTHER
  ENROLLED_IN_OTHERS_DOUBLE_WORK: "double work",
  ENROLLED_IN_OTHERS_PAID_LEAVE_PREVIOUS_EMPLOYMENT:
    "taking paid leave from previous employment",

  // SOCIAL INSURANCE TYPE
  SOCIAL_INSURANCE_WELFARE_PENSION: "welfare pension",
  SOCIAL_INSURANCE_HEALTH_INSURANCE: "health insurance",

  // WELFARE PENSION STATUS
  YEARS_70_OR_OLDER_LOSS: "70 years or older (late-stage elderly) / loss",

  // HEALTH INSURANCE DETAIL
  YEARS_40_OR_OLDER_HAS_NURSING_INSURANCE:
    "40 years or older / oas nursing insurance",
  LESS_THAN_40_YEARS_OLD_NO_NURSING_INSURANCE:
    "less than 40 years old / no nursing insurance",

  // PERSONAL IDENTIFICATION
  PERSONAL_IDENTIFICATION_DRIVERS_LICENCE: "driver-license",
  PERSONAL_IDENTIFICATION_MY_NUMBER_CARD: "number-card",
  PERSONAL_IDENTIFICATION_PASSPORT: "passport",
  PERSONAL_IDENTIFICATION_RESIDENCE_CARD: "residence-card",
  PERSONAL_IDENTIFICATION_BASIC_RESIDENCE_REGISTRATION_CARD:
    "basic-residence-card",
  PERSONAL_IDENTIFICATION_STUDENT_ID: "id-student",

  // RESIDENCE CARD TYPE
  RESIDENCE_CARD_PERMANENT_RESIDENT: "Permanent Resident",
  RESIDENCE_CARD_LONG_TERM_RESIDENT: "Long-Term Resident",
  RESIDENCE_CARD_SPOUSE_OF_JAPANESE_NATIONAL: "Spouse of Japanese National",
  RESIDENCE_CARD_SPOUSE_OF_PERMANENT_RESIDENT: "Spouse of Japanese Resident",

  // MONTH ADJUSTMENT RULE
  NEXT_MONTH: "Next Month",
  THIS_MONTH: "This Month",
  NEXT_BUSINESS_DAY: "Next Business Day",
  AFTER_SENDING: "After Sending",

  // SHIFT DATE BY
  PREVIOUS_DAY: "Previous Day",
  NEXT_DAY: "Next Day",

  // DELIVERY METHOD
  MAIL: "Mail",
  FAX: "Fax",
  BRANCH_MAMAGER_MAIL: "Branch Manager Mail",
  UNNECESSARY: "Unnecessary",
  POSTAL_MAIL: "Postal Mail",
  WEB_SETTLEMENT: "Web Settlement",

  // CALCULATION METHOD
  SEXAGESIMAL: "sexagesimal",
  DECIMAL: "decimal",

  // OVERTIME PREMIUM METHOD
  ACTUAL_WORKING_HOURS_ABOVE_X: "actual_working_hours",
  AFTER_REGULAR_WORKING_HOURS: "after_regular_working",

  // HOLIDAY PREMIUM METHOD
  ABOVE_XHOURS: "above_x_hours",
  SATURDAY_125_SUNDAY_135_HOLIDAY_125: "ssh",
  SATURDAY_125_SUNDAY_135: "ss",
  SIXTH_DAY_125_7TH_DAY_135: "6d_7d",

  // ONLINE PAYMENT PLATFORM
  ESTAFFING: "e-staffing",
  GOODJOB: "goodjob",

  // ONLINE PAYMENT PRICING
  ONLINE_PAYMENT_PRICING_FREE: "free",
  ONLINE_PAYMENT_PRICING_PAID: "paid",

  // CLIENT TIME CARD TYPE
  CLIENT_TIME_CARD_TYPE_HOTSTAFF: "hotstaff's time card",

  //DISPATCH TYPE
  REGISTRATION_BASED: "Registration-based",
  PERMANENT_EMPLOYEE: "Permanent employee",
  TEMP_TO_PERM: "Temp-to-perm",
  SHORT: "Short-term",
  HIGHLY_SKILLED_PROFESSIONAL: "Highly skilled professional",

  // EMPLOYMENT TRAINING
  NEW_EMPLOYEE_TRAINING: "New Employee Training",
  SAFETY_AND_HEALTH_EDUCATION: "Safety And Health Education",
  OJT: "OJT",

  // USABILITY
  USABLE: "usable",
  UNUSABLE: "un-usable",

  // FACILITY_USABLE
  ANYTIME: "anytime",
  SET_SPECIFIC_HOURS: "set specific hours",
  FACILITY_UNUSABLE: "facility un-usable",

  // FACILITY
  FACILITY_UNIFORM: "uniform",
  FACILITY_CAFETERIA: "cafeteria",
  FACILITY_BREAK_ROOM: "break room",
  FACILITY_CHANGING_ROOM: "changing room",
  FACILITY_LOCKER: "locker",
  FACILITY_PARKING_LOT: "parking lot",
  FACILITY_HOSPITAL: "hospital",
  FACILITY_CLINIC: "clinic",
  FACILITY_BATHHOUSE: "bathhouse",
  FACILITY_SHOP: "shop",
  FACILITY_BARBER_SHOP: "barber shop",
  FACILITY_NURSERY: "nursery",
  FACILITY_LIBRARY: "library",
  FACILITY_AUDITORIUM: "auditorium",
  FACILITY_RECREATION_ROOM: "recreation room",
  FACILITY_SPORTS_GROUND: "sports ground",
  FACILITY_GYMNASIUM: "gymnasium",
  FACILITY_RECUPERATION_FACILITY: "recuperation facility",
  FACILITY_RECREATION_FACILITY: "recreation facility",

  // FACILITY AVAILABILITY
  FACILITY_AVAILABLE: "facilities_available",
  NO_FACILITY_AVAILABLE: "no_facilities_available",

  // AIR CONDITIONING
  AIR_CONDITIONING_FULL_AIR_CONDITIONING: "full air conditioning",
  AIR_CONDITIONING_SPOT_AIR_CONDITIONING: "spot air conditioning",
  AIR_CONDITIONING_NONE: "none",
  AIR_CONDITIONING_OUTDOORS: "outdoors",

  // JOB LISTING EMPLOYMENT TYPE
  JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH: "Dispatch",
  JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH_PART_TIME: "Dispatch (Part-Time)",
  JOB_LISTING_EMPLOYMENT_TYPE_TEMP_TO_PERM_PLACEMENT: "Temp-to-Perm Placement",
  JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FULL_TIME_EMPLOYEE:
    "Employment Placement/Full-Time Employee",
  JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FIXED_TERM_EMPLOYEE:
    "Employment Placement/Fixed-Term Employee",
  JOB_LISTING_EMPLOYMENT_TYPE_FULL_TIME_EMPLOYEE_INCLUDING_PART_TIME:
    "Full-Time Employee (Including Part-Time)",

  // JOB TYPE ID
  JOB_TYPE_ID_EMPLOYMENT_SECURITY_OPERATIONS_STATISTICS: "employment_security",
  JOB_TYPE_ID_BASIC_WAGE_STRUCTURE_STATISTICS: "basic_wage_structure",

  // WORKING ON HOLIDAY
  WORKING_ON_HOLIDAY_MONTHLY_AVERAGE: "monthly",
  WORKING_ON_HOLIDAY_YEARLY_AVERAGE: "yearly",

  // WORKING OVERTIME
  WORKING_OVERTIME_DAILY_AVERAGE: "daily_average",

  // JOB LISTING DURATION
  JOB_LISTING_DURATION_TYPE_LONG_TERM: "long_term",
  JOB_LISTING_DURATION_TYPE_SHORT_TERM: "short_term",

  // JOB LISTING HOLIDAY
  JOB_LISTING_HOLIDAY_WEEKENDS_OFF: "Weekends Off",
  JOB_LISTING_HOLIDAY_FULL_WEEKENDS_OFF: "Full Weekends Off",
  JOB_LISTING_HOLIDAY_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF:
    "Weekends And Public Holidays Off",
  JOB_LISTING_HOLIDAY_FULL_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF:
    "Full Weekends And Public Holidays Off",
  JOB_LISTING_HOLIDAY_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED:
    "Two Days Off Per Week (Shift-Based)",
  JOB_LISTING_HOLIDAY_FULL_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED:
    "Full Two Days Off Per Week (Shift-Based)",
  JOB_LISTING_HOLIDAY_DAYS_ON_DAYS_OFF: "O Days On O Days Off",
  JOB_LISTING_HOLIDAY_WEEKDAYS_OFF: "Weekdays Off",

  // JOB LISTING HOLIDAY FIXED TYPE
  JOB_LISTING_HOLIDAY_FIXED_TYPE_FIXED_WEEKDAYS: "fixed",
  JOB_LISTING_HOLIDAY_FIXED_TYPE_NO_FIXED_WEEKDAYS: "no_fixed",

  // JOB LISTING ALLOWANCE
  JOB_LISTING_ALLOWANCE_PERFECT_ATTENDANCE_ALLOWANCE:
    "perfect attandance allowance",
  JOB_LISTING_ALLOWANCE_DILIGENCE_ALLOWANCE: "diligent allowance",
  JOB_LISTING_ALLOWANCE_MEAL_ALLOWANCE: "meal allowance",
  JOB_LISTING_ALLOWANCE_HOUSING_ALLOWANCE: "housing allowance",
  JOB_LISTING_ALLOWANCE_FAMILY_ALLOWANCE: "family allowance",
  JOB_LISTING_ALLOWANCE_YEAR_END_AND_NEW_YEAR_ALLOWANCE:
    "year-end and new year allowance",

  //OFFICE WORKER QUALIFICATION
  DISPATCHING_AGENCY_MANAGER: "Dispatching Agency Manager",
  EMPLOYMENT_PLACEMENT_MANAGER: "Employment Placement Manager",
  MANUFACTURING_SPECIALIZED_DISPATCHING_AGENCY_MANAGER:
    "Manufacturing Specialized Dispatching Agency Manager",
  SECOND_CLASS_HEALTH_SUPERVISOR: "Second-Class Health Supervisor",

  // GENDER
  GENDER_MALE: "male",
  GENDER_FEMALE: "female",
  GENDER_MALE_FEMALE: "male and female",

  // USABILITY
  USABILITY_REQUIRED: "required",
  USABILITY_NEGOTIABLE: "negotiable",

  // DESIRED NATIONALITY
  DESIRED_NATIONALITY_JAPANSESE_ONLY: "japanese only",
  DESIRED_NATIONALITY_FOREIGN_WORKERS_ONLY: "foreign workers only",
  DESIRED_NATIONALITY_JAPANSESE_AND_FOREIGN_WORKERS:
    "japanese and foreign workers",

  // JOB LISTING CERTIFICATIONS
  JOB_LISTING_CERTIFICATIONS_DRIVERS_LICENSE: "driver's license",
  JOB_LISTING_CERTIFICATIONS_LARGE_VEHICLE_DRIVERS_LICENSE:
    "large vehicle driver's license",
  JOB_LISTING_CERTIFICATIONS_FORKLIFT_CERTIFICATION: "forklift certification",
  JOB_LISTING_CERTIFICATIONS_SLINGING_CERTIFICATION: "slinging certification",
  JOB_LISTING_CERTIFICATIONS_CRANE_CERTIFICATION: "crane certification",
  JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_3: "bookkeeping level 3",
  JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_2: "bookkeeping level 2",
  JOB_LISTING_CERTIFICATIONS_NURSERY_TEACHER_LICENSE: "nursery teacher license",
  JOB_LISTING_CERTIFICATIONS_KINDERGARTEN_TEACHER_LICENSE:
    "kindergarten teacher license",
  JOB_LISTING_CERTIFICATIONS_COOK_LICENSE: "cook license",
  JOB_LISTING_CERTIFICATIONS_NUTRITIONIST_LICENSE: "nutritionist license",
  JOB_LISTING_CERTIFICATIONS_HELPER_LEVEL_2: "helper level 2",
  JOB_LISTING_CERTIFICATIONS_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING:
    "certified care worker beginner training",

  // JOB LISTING EXPERIENCE
  JOB_LISTING_EXPERIENCE_MANUFACTURING_EXPERIENCE: "manufacturing experience",
  JOB_LISTING_EXPERIENCE_INSPECTION_EXPERIENCE: "inspection experience",
  JOB_LISTING_EXPERIENCE_FORKLIFT_OPERATION_EXPERIENCE:
    "forklift operation experience",
  JOB_LISTING_EXPERIENCE_MACHINE_OPERATION_EXPERIENCE:
    "machine operation experience",
  JOB_LISTING_EXPERIENCE_FOOD_MANUFACTURING_EXPERIENCE:
    "food manufacturing experience",
  JOB_LISTING_EXPERIENCE_CLERICAL_WORK_EXPERIENCE: "clerical work experience",
  JOB_LISTING_EXPERIENCE_TELEPHONE_HANDLING_EXPERIENCE:
    "telephone handling experience",

  REQUIRED: "required",
  RECOMENDEED: "recommended",

  PRODUCTION: "Production",
  WHITE_COLLAR: "White-Collar",

  DAILY: "daily",
  HOURLY: "hourly",

  // EARPLUG
  USE_EARPLUG: "earplugs",
  NO_EARPLUG: "no_earplugs",

  // UNIFORM
  UNIFORM_PROVIDED: "Uniform Provided",
  PREPARE_OWN: "Prepare Own",
  NONE: "None",

  // MID SHIFT BREAK METHOD
  GOING_PUT_PERMITTED: "going out permitted",
  STAYING_IN_CAR_PERMITTED: "staying in car permitted",
  TEMPORARY_RETURN_HOME_PERMITTED: "temporary return home permitted",

  // GROOMING
  BLACK_TO_DARK_BROWN: "Black to Dark Brown",
  BLACK: "Black",
  SIMPLE_NAILS_OK: "Simple Nails OK",
  NOT_ALLOWED: "Not Allowed",
  OK_IF_HIDDEN: "OK if Hidden",
  NO_TATTOOS: "No Tattoos",
  OK_IF_KEPT_CLEAN: "OK if Kept Clean",
  NO_BREADS: "No Beards",

  // EMPLOYMENT QUALIFICATION
  EMPLOYMENT_QUALIFICATION_DRIVERS_LICENSE: "Driver's License",
  EMPLOYMENT_QUALIFICATION_CLASS_2_HEALTH_SUPERVISOR:
    "Class 2 Health Supervisor",
  EMPLOYMENT_QUALIFICATION_DISPATCHING_AGENCY_MANAGER:
    "Dispatching Agency Manager",
  EMPLOYMENT_QUALIFICATION_FEE_CHARGING_EMPLOYMENT_PLACEMENT_MANAGER:
    "Fee-Charging Employment Placement Manager",
  EMPLOYMENT_QUALIFICATION_CAREER_CONSULTANT: "Career Consultant",

  // EMPLOYMENT POST
  EMPLOYMENT_POST_GM: "gm",
  EMPLOYMENT_POST_AM: "am",
  EMPLOYMENT_POST_BRANCH_MANAGER: "branch manager",
  EMPLOYMENT_POST_EXECUTIVE_GENERAL_MANAGER: "executive general manager",
  EMPLOYMENT_POST_DEPARTMENT_MANAGER: "department manager",
  EMPLOYMENT_POST_DEPUTY_GENERAL_SECTION_MANAGER:
    "deputy general section manager",
  EMPLOYMENT_POST_DEPUTY_GENERAL_MANAGER: "deputy general manager",
  EMPLOYMENT_POST_GENERAL_SECTION_MANAGER: "general section manager",
  EMPLOYMENT_POST_SECTION_MANAGER: "section manager",
  EMPLOYMENT_POST_ASSISTANT: "assistant",
  EMPLOYMENT_POST_STAFF: "staff",
  EMPLOYMENT_POST_SECTION_CHIEF: "section chief",
  EMPLOYMENT_POST_SUPERVISOR: "supervisor",

  // AFFILIATED BRANCH
  AFFILIATED_BRANCH_BRANCH: "Branch",
  AFFILIATED_BRANCH_MAIN: "Main",
  AFFILIATED_BRANCH_HEADQUARTER: "Headquarter",

  // EMPLOYMENT BRANCH TYPE
  EMPLOYMENT_BRANCH_TYPE_SALES_DEPARTMENT: "Sales Department",
  EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_DEPARTMENT: "Administration Department",
  EMPLOYMENT_BRANCH_TYPE_CLERICAL: "Clerical",
  EMPLOYMENT_BRANCH_TYPE_COORDINATOR: "Coordinator",
  EMPLOYMENT_BRANCH_TYPE_ATTENDANT: "Attendant",
  EMPLOYMENT_BRANCH_TYPE_IT_DEPARTMENT: "IT Department",
  EMPLOYMENT_BRANCH_TYPE_PUBLIC_RELATIONS_DEPARTMENT:
    "Public Relations Department",
  EMPLOYMENT_BRANCH_TYPE_MARKETING_DEPARTMENT: "Marketing Department",
  EMPLOYMENT_BRANCH_TYPE_CONTROL_DEPARTMENT: "Control Department",
  EMPLOYMENT_BRANCH_TYPE_GENERAL_AFFAIRS_SECTION: "General Affairs Section",
  EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_SECTION: "Administration Section",
  EMPLOYMENT_BRANCH_TYPE_EDUCATION_SECTION: "Education Section",
  EMPLOYMENT_BRANCH_TYPE_HUMAN_RESOURCES_SECTION: "Human Resources Section",
  EMPLOYMENT_BRANCH_TYPE_SECTION_ONE: "Section One",
  EMPLOYMENT_BRANCH_TYPE_SECTION_TWO: "Section Two",

  //CLIENT POC
  ORGANIZATION_CHIEF: "Organization Chief",
  COMMANDER: "Commander",
  CORPORATION_PIC: "Corporation of Person In-charge",
  CORPORATION_COMPLAINT_OFFICER: "Corporation Complaint Officer",
  HOTSTAFF_PIC: "HotStaff Person In-Charge",
  HOTSTAFF_COMPLAINT_OFFICER: "HotStaff Complaint Officer",

  // JOB LISTING CATEGORY
  JOB_CATEGORY_MANUFACTURING_LIGHT_WORK: "Manufacturing / Light work",
  JOB_CATEGORY_FOOD_MANUFACTURING: "Food manufacturing",
  JOB_CATEGORY_LOGISTICS_WAREHOUSE_MANAGEMENT:
    "Logistics / Warehouse management",
  JOB_CATEGORY_CLERICAL_OFFICE_WORK: "Clerical / Office work",
  JOB_CATEGORY_MEDICAL_NURSING_CARE_WELFARE: "Medical / Nursing care / Welfare",
  JOB_CATEGORY_SALES_RETAIL_SERVICE_INDUSTRY:
    "Sales / Retail / Service industry",
  JOB_CATEGORY_FOOD_SERVICE_HOSPITALITY: "Food service / Hospitality",
  JOB_CATEGORY_CONVENIENCE_STORE_SUPERMARKET: "Convenience store / Supermarket",
  JOB_CATEGORY_IT_CREATIVE_TECHNICAL: "IT / Creative / Technical",

  // NEAREST_STATION_MODE_OPTIONS
  NEAREST_STATION_MODE_CAR: "Car",
  NEAREST_STATION_MODE_WALKING: "Walking",
  NEAREST_STATION_MODE_BUS: "Bus",
  NEAREST_STATION_MODE_TRAIN: "Train",

  // KANBAN TITLE
  KANBAN_TITLE_CONFIRM_STAFF_NEEDS: "confirm staff needs",
  KANBAN_TITLE_ADJUSTING_INTERVIEW_DATE: "adjusting interview date",
  KANBAN_TITLE_CONFIRMED_INTERVIEW_DATE: "confirmed interview date",
  KANBAN_TITLE_STAFF_AWAITING_RECOMMENDATIONS: "staff awaiting recommendations",
  KANBAN_TITLE_SALES_PREPARATION: "sales preparation",
  KANBAN_TITLE_CREATE_SALES_MATERIAL: "create sales material",
  KANBAN_TITLE_SALES_IN_PROGRESS: "sales in progress",
  KANBAN_TITLE_NEGOTIATE_ORDER_DETAILS: "negotiate order details",
  KANBAN_TITLE_TAKING_ORDERS: "taking orders",
  KANBAN_TITLE_ASSEMBLE_TEAM: "assemble team",
  KANBAN_TITLE_ADJUSTING_WORKPLACE_TOUR: "adjusting workplace tour",
  KANBAN_TITLE_WORKPLACE_TOUR_IN_PROGRESS: "workplace tour in progress",
  KANBAN_TITLE_AWAITING_CLIENT_RESPONSE: "awaiting client response",
  KANBAN_TITLE_CONFIRM_TERMS: "confirm terms",
  KANBAN_TITLE_PROCESSING_LEDGER_STATEMENTS: "processing ledger statements",
  KANBAN_TITLE_CLIENT_CONTRACT_CLOSING: "client contract closing",
  KANBAN_TITLE_FIRST_DAY_OF_DISPATCH_WORK: "first day of dispatch work",
  KANBAN_TITLE_PROCESSING_EMPLOYMENT_INSURANCE:
    "processing employment insurance",
  KANBAN_TITLE_PROCESSING_SOCIAL_INSURANCE: "processing social insurance",
  KANBAN_TITLE_STAFF_EMPLOYED: "staff employed",

  // KANBAN
  KANBAN_FIELD_SALES: "field sales",
  KANBAN_INSIDE_SALES: "inside sales",
};

export const MAP_TRANSLATION: Record<string, string> = {
  // LATE_NIGHT_CALCULATION_METHOD_OPTIONS
  [TRANSLATION_KEY.UNIT_RATE]: "unit_rate",
  [TRANSLATION_KEY.ALLOWANCE]: "allowance",

  // CONSUMPTION_TAX_OPTIONS
  [TRANSLATION_KEY.ROUNDING]: "rounding",
  [TRANSLATION_KEY.ROUNDING_UP]: "rounding_up",
  [TRANSLATION_KEY.ROUNDING_DOWN]: "rounding_down",

  // CURRENCY_OPTIONS
  [TRANSLATION_KEY.YEN]: "yen",

  // WEIGHT_OPTIONS
  [TRANSLATION_KEY.G]: "g",
  [TRANSLATION_KEY.KG]: "kg",

  // METRIK_OPTIONS
  [TRANSLATION_KEY.CM]: "cm",
  [TRANSLATION_KEY.M]: "m",

  // EMPLOYMENT_TYPE_OPTIONS
  [TRANSLATION_KEY.PERMANENT]: "permanent",
  [TRANSLATION_KEY.FEE_CHARGING_EMPLOYMENT_PLACEMENT]:
    "fee_charging_employment_placement",
  [TRANSLATION_KEY.SHORT_TERM]: "short_term",

  // FREQUENCY_WORKING_HOLIDAYS_OPTIONS
  [TRANSLATION_KEY.CORPORATE_CALENDAR]: "corporate_calendar",
  [TRANSLATION_KEY.DAY_OF_WEEK]: "day_of_the_week",
  [TRANSLATION_KEY.ROTATION]: "rotation",

  // ALLOWANCE_TYPE_OPTIONS
  [TRANSLATION_KEY.TRANSPORTATION]: "transportation",
  [TRANSLATION_KEY.MEAL]: "meal",
  [TRANSLATION_KEY.HOUSING]: "housing",
  [TRANSLATION_KEY.HEALTH_CHECKUP]: "health_checkup",
  [TRANSLATION_KEY.TRAVEL]: "travel",
  [TRANSLATION_KEY.SELF_DEVELOPMENT]: "self_development",

  // UNIFORM_LOAN_OPTIONS
  [TRANSLATION_KEY.FREE]: "free",
  [TRANSLATION_KEY.LOAN]: "loan",
  [TRANSLATION_KEY.OWN]: "own",

  // HAIR_GROOMING_OPTIONS
  [TRANSLATION_KEY.HAIR_FREE]: "hair_free",

  // SMOKING_ENVIRONMENT_OPTIONS
  [TRANSLATION_KEY.NO_SMOKING_ON_PERMISES]: "no_smoking_on_permises",
  [TRANSLATION_KEY.INDOOR_SEPARATE_SMOKE_AREA]: "indoor_separate_smoke_area",
  [TRANSLATION_KEY.OUTDOOR_SEPARATE_SMOKE_AREA]: "outdoor_separate_smoke_area",

  // INVOICE_BEGIN_DATE_OPTIONS
  [TRANSLATION_KEY.FORTY_HOURS_PER_WEEK]: "40_hours_per_week",
  [TRANSLATION_KEY.SIX_DAYS]: "6_days",
  [TRANSLATION_KEY.SEVEN_DAYS]: "7_days",

  // WORKFORCE_MANAGEMENT_OPTIONS
  [TRANSLATION_KEY.LABOR_MANAGEMENT_AGREEMENT_METHOD]:
    "labor_management_agreement_method",
  [TRANSLATION_KEY.EQUAL_BALANCED_TREATMENT_METHOD]:
    "equal_balanced_treatment_method",

  // CORPORATION_TYPE
  [TRANSLATION_KEY.CORPORATION]: "corporation_type_corporation",
  [TRANSLATION_KEY.LIMITED_COMPANY]: "corporation_type_limited_company",
  [TRANSLATION_KEY.GENERAL_PARTNERSHIP]: "corporation_type_general_partnership",
  [TRANSLATION_KEY.LIMITED_PARTNERSHIP]: "corporation_type_limited_partnership",
  [TRANSLATION_KEY.LLC]: "corporation_type_llc",
  [TRANSLATION_KEY.FOREIGN_COMPANY]: "corporation_type_foreign_company_etc",
  [TRANSLATION_KEY.NATIONAL_GOVERNMENT_AGENCY]:
    "corporation_type_national_government_agency",
  [TRANSLATION_KEY.LOCAL_PUBLIC_ENTITY]: "corporation_type_local_public_entity",
  [TRANSLATION_KEY.OTHER_INCORPORATED_ENTITY]:
    "corporation_type_other_incorporated_entity",
  [TRANSLATION_KEY.OTHER]: "corporation_type_other",

  [TRANSLATION_KEY.OTHER_NEW]: "other",
  [TRANSLATION_KEY.OTHERS]: "others",

  // PIPELINE_STATUS
  [TRANSLATION_KEY.INCREASE_STAFF]: "pipeline_status_increase_staff",
  [TRANSLATION_KEY.NEGOTIATING]: "pipeline_status_negotiating",

  // PIPELINE
  [TRANSLATION_KEY.NEW_DEVELOPEMENT]: "pipeline_new_developement",
  [TRANSLATION_KEY.UPSELL]: "pipeline_upsell",
  [TRANSLATION_KEY.CROSS_SELL]: "pipeline_cross_sell",

  // GRADE_OPTIONS
  [TRANSLATION_KEY.REQUIRING_SUPPORT_1]: "requiring_support_1",
  [TRANSLATION_KEY.REQUIRING_SUPPORT_2]: "requiring_support_2",
  [TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_1]: "requiring_long_term_care_1",
  [TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_2]: "requiring_long_term_care_2",
  [TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_3]: "requiring_long_term_care_3",
  [TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_4]: "requiring_long_term_care_4",
  [TRANSLATION_KEY.REQUIRING_LONG_TERM_CARE_5]: "requiring_long_term_care_5",

  // REASON_NOT_JOINING_INSURANCE_OPTIONS
  [TRANSLATION_KEY.MONTHLY_INCOME_OF_88000_YEN_OR_LESS]:
    "reason_not_joining.income",
  [TRANSLATION_KEY.BEING_A_STUDENT]: "reason_not_joining.student",
  [TRANSLATION_KEY.WORKING_WITHIN_20_HOURS_PER_WEEK]:
    "reason_not_joining.hours",

  // EMPLOYEMENT_INSURANCE_STATUS_OPTIONS
  [TRANSLATION_KEY.RENEWAL]: "renewal",

  // PREFERRED_EMPLOYMENT_DURATION_VALUE
  [TRANSLATION_KEY.LONG_TERM]: "preferred_employment_duration.long_term",
  [TRANSLATION_KEY.SHORT_TERM]: "preferred_employment_duration.short_term",

  // BREAK_TIME_OPTIONS
  [TRANSLATION_KEY.MINUTES]: "minutes",
  [TRANSLATION_KEY.HOUR]: "hour",
  [TRANSLATION_KEY.HOURS]: "hours",

  // WAGE_TIME_VALUE
  [TRANSLATION_KEY.WEEK]: "week",
  [TRANSLATION_KEY.MONTH]: "month",

  // PREFERRED_WORKING_SCHEDULE_OPTIONS
  [TRANSLATION_KEY.DAY_SHIFT]: "preferred_working_schedule.day_shift",
  [TRANSLATION_KEY.NIGHT_SHIFT]: "preferred_working_schedule.night_shift",
  [TRANSLATION_KEY.ROTATIONAL_SHIFT]:
    "preferred_working_schedule.rotational_shift",
  [TRANSLATION_KEY.ROTATIONAL_SHIFT_INCLUDING_MIDNIGHT]:
    "preferred_working_schedule.rotational_shift.including_midnight",
  [TRANSLATION_KEY.ROTATIONAL_SHIFT_EXCLUDING_MIDNIGHT]:
    "preferred_working_schedule.rotational_shift.excluding_midnight",

  // POWER_OPTIONS
  [TRANSLATION_KEY.POWER_0]: "0.00",
  [TRANSLATION_KEY.POWER_0_5]: "+0.50",
  [TRANSLATION_KEY.POWER_0_75]: "+0.75",
  [TRANSLATION_KEY.POWER_1]: "+1.00",
  [TRANSLATION_KEY.POWER_1_25]: "+1.25",
  [TRANSLATION_KEY.POWER_1_5]: "+1.50",
  [TRANSLATION_KEY.POWER_1_75]: "+1.75",
  [TRANSLATION_KEY.POWER_2]: "+2.00",
  [TRANSLATION_KEY.POWER_2_25]: "+2.25",
  [TRANSLATION_KEY.POWER_2_5]: "+2.50",
  [TRANSLATION_KEY.POWER_2_75]: "+2.75",
  [TRANSLATION_KEY.POWER_3]: "+3.00",
  [TRANSLATION_KEY.POWER_3_25]: "+3.25",
  [TRANSLATION_KEY.POWER_3_5]: "+3.50",
  [TRANSLATION_KEY.POWER_3_75]: "+3.75",
  [TRANSLATION_KEY.POWER_4]: "+4.00",

  // MARTIAL_STATUS_OPTIONS
  [TRANSLATION_KEY.MARRIED]: "married",
  [TRANSLATION_KEY.UNMARRIED]: "unmarried",
  [TRANSLATION_KEY.DIVORCED]: "divorced",
  [TRANSLATION_KEY.WIDOWED]: "widowed",

  // COMMUTING_METHOD_OPTIONS
  [TRANSLATION_KEY.CAR]: "commuting_method.car",
  [TRANSLATION_KEY.BICYCLE]: "commuting_method.bicycle",
  [TRANSLATION_KEY.MOPED]: "commuting_method.moped",
  [TRANSLATION_KEY.MOTORCYCLE]: "commuting_method.motorcycle",
  [TRANSLATION_KEY.WALKING]: "commuting_method.walking",
  [TRANSLATION_KEY.PUBLIC_TRANSPORTATION]: "commuting_method.public",

  // TERM_EMPLOYMENT_OPTIONS
  [TRANSLATION_KEY.FIXED]: "fixed",
  [TRANSLATION_KEY.INDEFINITE]: "indefinite",

  // MONTH_DAYS_OPTIONS
  [TRANSLATION_KEY.LAST_DAY_OF_MONTH]: "last_day_of_month",

  // STAFF STATUS
  [TRANSLATION_KEY.TEMPORARY_STAFF]: "temporary_staff",
  [TRANSLATION_KEY.WORKING_STAFF]: "working_staff",
  [TRANSLATION_KEY.POOL_STAFF]: "pool_staff",

  //COUNTRY
  [TRANSLATION_KEY.COUNTRY_JAPAN]: "country_japan",
  [TRANSLATION_KEY.COUNTRY_US]: "country_america",
  [TRANSLATION_KEY.COUNTRY_UK]: "country_united_kingdom",
  [TRANSLATION_KEY.COUNTRY_ITALY]: "country_italy",
  [TRANSLATION_KEY.COUNTRY_INDONESIA]: "country_indonesia",
  [TRANSLATION_KEY.COUNTRY_AUSTRALIA]: "country_australia",
  [TRANSLATION_KEY.COUNTRY_CANADA]: "country_canada",
  [TRANSLATION_KEY.COUNTRY_SOUTH_KOREA]: "country_south_korea",
  [TRANSLATION_KEY.COUNTRY_CHINA]: "country_china",
  [TRANSLATION_KEY.COUNTRY_GERMANY]: "country_germany",
  [TRANSLATION_KEY.COUNTRY_NEPAL]: "country_nepal",
  [TRANSLATION_KEY.COUNTRY_PHILIPPINES]: "country_philippines",
  [TRANSLATION_KEY.COUNTRY_FRANCE]: "country_france",
  [TRANSLATION_KEY.COUNTRY_BRAZIL]: "country_brazil",
  [TRANSLATION_KEY.COUNTRY_VIETNAM]: "country_vietnam",
  [TRANSLATION_KEY.COUNTRY_PERU]: "country_peru",
  [TRANSLATION_KEY.COUNTRY_MYANMAR]: "country_myanmar",
  [TRANSLATION_KEY.COUNTRY_TAIWAN]: "country_taiwan",
  [TRANSLATION_KEY.COUNTRY_THAILAND]: "country_thailand",

  //TAG TYPE
  [TRANSLATION_KEY.TAG_STAFF]: "staff",
  [TRANSLATION_KEY.TAG_CORPORATION]: "corporation",
  [TRANSLATION_KEY.TAG_JOB_LISTING]: "joblisting",
  [TRANSLATION_KEY.TAG_TICKET]: "tickets",

  //RELATIONSHIP
  [TRANSLATION_KEY.RELATIONSHIP_FATHER]: "family_structure.father",
  [TRANSLATION_KEY.RELATIONSHIP_MOTHER]: "family_structure.mother",
  [TRANSLATION_KEY.RELATIONSHIP_GRANDFATHER]: "family_structure.grandfather",
  [TRANSLATION_KEY.RELATIONSHIP_GRANDMOTHER]: "family_structure.grandmother",
  [TRANSLATION_KEY.RELATIONSHIP_CHILD]: "relationship.child",
  [TRANSLATION_KEY.RELATIONSHIP_GRANDCHILD]: "relationship.grandchild",
  [TRANSLATION_KEY.RELATIONSHIP_FRIEND]: "relationship.friend",

  //POSIBILITY
  [TRANSLATION_KEY.POSSIBILITY_POSSIBLE]: "possible",
  [TRANSLATION_KEY.POSSIBILITY_NOT_POSSIBLE]: "not_possible",

  //REJECT JOB TYPES
  [TRANSLATION_KEY.REJECT_JOB_TYPES_FOOD_MANUFACTURING]:
    "reject_job_types.food_manufacturing",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_CLEAN_ROOM]: "reject_job_types.clean_room",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_ASSEMBLY_LINE_WORK]:
    "reject_job_types.assembly_line_work",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_HEAVY_LIFTING]:
    "reject_job_types.heavy_lifting",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_STANDING_WORK]:
    "reject_job_types.standing_work",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_STATIONARY_WORK]:
    "reject_job_types.stationary_work",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_WORK_REQUIRING_GOOD_EYESIGHT]:
    "reject_job_types.work_requiring_good_eyesight",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_HOT_ENVIRONMENT]:
    "reject_job_types.hot_environment",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_COLD_ENVIRONMENT]:
    "reject_job_types.cold_environment",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_CUSTOMER_SERVICE]:
    "reject_job_types.customer_service",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_CLERICAL_WORK]:
    "reject_job_types.clerical_work",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_NURSING_CARE]:
    "reject_job_types.nursing_care",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_MANUFACTURING]:
    "reject_job_types.manufacturing",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_LOGISTICS]: "reject_job_types.logistics",
  [TRANSLATION_KEY.REJECT_JOB_TYPES_SALES]: "reject_job_types.sales",

  //DESIRED JOB TYPES
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_CUSTOMER_SERVICE]:
    "desired_job_types.customer_service",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_CLERICAL_WORK]:
    "desired_job_types.clerical_work",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_NURSING_CARE]:
    "desired_job_types.nursing_care",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_COOKING]: "desired_job_types.cooking",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_FORKLIFT_OPERATION]:
    "desired_job_types.forklift_operation",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_PICKING]: "desired_job_types.picking",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_DELIVERY]: "desired_job_types.delivery",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_MANUFACTURING]:
    "desired_job_types.manufacturing",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_LOGISTICS]: "desired_job_types.logistics",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_FOOD_MANUFACTURING]:
    "desired_job_types.food manufacturing",
  [TRANSLATION_KEY.DESIRED_JOB_TYPES_SITTING_WORK]:
    "desired_job_types.sitting_work",

  //PHYSICAL CHARACTERISTICS
  [TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_DYED_HAIR]:
    "physical_characteristics.dyed_hair",
  [TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_SHAVED_HEAD]:
    "physical_characteristics.shaved_head",
  [TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_BEARD]:
    "physical_characteristics.beard",
  [TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_NAIL_ART]:
    "physical_characteristics.nail_art",
  [TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_NON_REMOVABLE_PIERCINGS]:
    "physical_characteristics.non_removable_piercings",
  [TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_TATTOOS]:
    "physical_characteristics.tattoos",
  [TRANSLATION_KEY.PHYSICAL_CHARACTERISTICS_SIZE_3L_OR_ABOVE]:
    "physical_characteristics.size_3l_or_above",

  //JAPANESE LANGUAGE LEVEL
  [TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_HIRAGANA]: "hiragana",
  [TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_KANJI]: "kanji",
  [TRANSLATION_KEY.JAPANESE_LANGUAGE_LEVEL_KATAKANA]: "katakana",

  //HEALTH CONDITION
  [TRANSLATION_KEY.HEALTH_CONDITION_NORMAL]: "normal",
  [TRANSLATION_KEY.HEALTH_CONDITION_HAS_CONDITION]: "has_condition",

  // STAFF QUALIFICATION
  [TRANSLATION_KEY.QUALIFITAION_DRIVERS_LICENSE]:
    "qualification.drivers_license",
  [TRANSLATION_KEY.QUALIFITAION_LARGE_VEHICLE_DRIVERS_LICENSE]:
    "qualification.large_vehicle_drivers_license",
  [TRANSLATION_KEY.QUALIFITAION_FORKLIFT_CERTIFICATION]:
    "qualification.forklift_certification",
  [TRANSLATION_KEY.QUALIFITAION_SLINGING_CERTIFICATION]:
    "qualification.slinging_certification",
  [TRANSLATION_KEY.QUALIFITAION_CRANE_CERTIFICATION]:
    "qualification.crane_certification",
  [TRANSLATION_KEY.QUALIFITAION_BOOKEEPING_LEVEL_3]:
    "qualification.bookeeping_level_3",
  [TRANSLATION_KEY.QUALIFITAION_BOOKEEPING_LEVEL_2]:
    "qualification.bookeeping_level_2",
  [TRANSLATION_KEY.QUALIFITAION_NURSERY_TEACHER_LICENSE]:
    "qualification.nursery_teacher_license",
  [TRANSLATION_KEY.QUALIFITAION_KINDERGARTEN_TEACHER_LICENSE]:
    "qualification.kindergarten_teacher_license",
  [TRANSLATION_KEY.QUALIFITAION_COOK_LICENSE]: "qualification.cook_license",
  [TRANSLATION_KEY.QUALIFITAION_NUTRITIONIST_LICENSE]:
    "qualification.nutritionist_license",
  [TRANSLATION_KEY.QUALIFITAION_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING]:
    "qualification.certified_care_worker_beginner_training",

  // EMPLOYMENT TYPE
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_PERMANENT_EMPLOYEE]:
    "employment_type.permanent_employee",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_CONTRACT_EMPLOYEE]:
    "employment_type.contract_employee",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_PART_TIME]: "employment_type.part_time",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_PART_TIME_ARBEIT]:
    "employment_type.part_time_arbeit",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_DISPATCH]: "employment_type.dispatch",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_OUTSOURCE]: "employment_type.outsource",
  [TRANSLATION_KEY.EMPLOYMENT_TYPE_SELF_EMPLOYED]:
    "employment_type.self_employed",

  // RESIGNATION REASON
  [TRANSLATION_KEY.RESIGNATION_REASON_CONTRACT_COMPLETION]:
    "resignation_reason.contract_completion",
  [TRANSLATION_KEY.RESIGNATION_REASON_PERSONAL_REASON]:
    "resignation_reason.personal_reason",
  [TRANSLATION_KEY.RESIGNATION_REASON_POOR_HEALTH]:
    "resignation_reason.poor_health",
  [TRANSLATION_KEY.RESIGNATION_REASON_CAREGIVING]:
    "resignation_reason.caregiving",
  [TRANSLATION_KEY.RESIGNATION_REASON_MOVING]: "resignation_reason.moving",
  [TRANSLATION_KEY.RESIGNATION_REASON_MARRIAGE]: "resignation_reason.marriage",
  [TRANSLATION_KEY.RESIGNATION_REASON_CHILDBIRTH]:
    "resignation_reason.childbirth",
  [TRANSLATION_KEY.RESIGNATION_REASON_CAREER_UP]:
    "resignation_reason.career_up",

  // TYPE OF WORK
  [TRANSLATION_KEY.TYPE_OF_WORK_ONSITE]: "onsite",
  [TRANSLATION_KEY.TYPE_OF_WORK_REMOTE]: "remote",
  [TRANSLATION_KEY.TYPE_OF_WORK_HYBRID]: "hybrid",

  // Field Study
  [TRANSLATION_KEY.FIELD_STUDY_NO_PREFERENCE]: "no_preference",
  [TRANSLATION_KEY.FIELD_STUDY_INDUSTRIAL]: "field_study.industrial",
  [TRANSLATION_KEY.FIELD_STUDY_COMMERCE]: "field_study.commerce",

  //ENROLLED STATUS
  [TRANSLATION_KEY.ENROLLED]: "enrolled",
  [TRANSLATION_KEY.NOT_ENROLLED]: "not_enrolled",

  // NOT ENROLLED REASON
  [TRANSLATION_KEY.LESS_THAN_20_HOURS_PER_WEEK]: "less_than_20_hours_per_week",
  [TRANSLATION_KEY.EXPECTED_LESS_THAN_31_DAYS]: "expected_less_than_31_days",
  [TRANSLATION_KEY.ENROLLED_IN_OTHERS]: "enrolled_in_others",
  [TRANSLATION_KEY.LESS_THAN_30_HOURS_PER_WEEK]: "less_than_30_hours_per_week",
  [TRANSLATION_KEY.MONTHLY_SALARY_UNDER_80K_YEN]:
    "monthly_salary_under_80k_yen",
  [TRANSLATION_KEY.MONTHLY_SALARY_UNDER_80K_YEN]:
    "monthly_salary_under_80k_yen",
  [TRANSLATION_KEY.EXPECTED_EMPLOYMENT_LESS_THAN_2MONTH]:
    "expected_employment_less_than_2month",
  [TRANSLATION_KEY.STUDENT]: "student",
  [TRANSLATION_KEY.YEARS_70_OR_OLDER]: "70_years_or_older",

  // ENROLLED IN OTHER
  [TRANSLATION_KEY.ENROLLED_IN_OTHERS_DOUBLE_WORK]:
    "details_of_enrolled_in_others.double_work",
  [TRANSLATION_KEY.ENROLLED_IN_OTHERS_PAID_LEAVE_PREVIOUS_EMPLOYMENT]:
    "details_of_enrolled_in_others.taking_paid_leave_from_previous_company",

  // SOCIAL INSURANCE TYPE
  [TRANSLATION_KEY.SOCIAL_INSURANCE_WELFARE_PENSION]: "welfare_pension",
  [TRANSLATION_KEY.SOCIAL_INSURANCE_HEALTH_INSURANCE]: "health_insurance",

  // WELFARE PENSION STATUS
  [TRANSLATION_KEY.YEARS_70_OR_OLDER_LOSS]: "70_years_or_older_loss",

  // HEALTH INSURANCE DETAIL
  [TRANSLATION_KEY.YEARS_40_OR_OLDER_HAS_NURSING_INSURANCE]:
    "40_years_or_older_has_nursing_insurance",
  [TRANSLATION_KEY.LESS_THAN_40_YEARS_OLD_NO_NURSING_INSURANCE]:
    "less_than_40_years_old_no_nursing_insurance",

  // PERSONAL IDENTIFICATION
  [TRANSLATION_KEY.PERSONAL_IDENTIFICATION_DRIVERS_LICENCE]:
    "personal_identification.drivers_licence",
  [TRANSLATION_KEY.PERSONAL_IDENTIFICATION_MY_NUMBER_CARD]:
    "personal_identification.my_number_card",
  [TRANSLATION_KEY.PERSONAL_IDENTIFICATION_PASSPORT]:
    "personal_identification.passport",
  [TRANSLATION_KEY.PERSONAL_IDENTIFICATION_RESIDENCE_CARD]:
    "personal_identification.residence_card",
  [TRANSLATION_KEY.PERSONAL_IDENTIFICATION_BASIC_RESIDENCE_REGISTRATION_CARD]:
    "personal_identification.basic_residence_registration_card",
  [TRANSLATION_KEY.PERSONAL_IDENTIFICATION_STUDENT_ID]:
    "personal_identification.student_id",

  // RESIDENCE CARD TYPE
  [TRANSLATION_KEY.RESIDENCE_CARD_PERMANENT_RESIDENT]:
    "residence_card.permanent_resident",
  [TRANSLATION_KEY.RESIDENCE_CARD_LONG_TERM_RESIDENT]:
    "residence_card.long_term_resident",
  [TRANSLATION_KEY.RESIDENCE_CARD_SPOUSE_OF_JAPANESE_NATIONAL]:
    "residence_card.spouse_of_japanese_national",
  [TRANSLATION_KEY.RESIDENCE_CARD_SPOUSE_OF_PERMANENT_RESIDENT]:
    "residence_card.spouse_of_permanent_resident",

  // MONTH ADJUSTMENT RULE
  [TRANSLATION_KEY.NEXT_MONTH]: "next_month",
  [TRANSLATION_KEY.THIS_MONTH]: "this_month",
  [TRANSLATION_KEY.NEXT_BUSINESS_DAY]: "next_business_day",
  [TRANSLATION_KEY.AFTER_SENDING]: "after_sending",

  // SHIFT DATE BY
  [TRANSLATION_KEY.PREVIOUS_DAY]: "previous_day",
  [TRANSLATION_KEY.NEXT_DAY]: "next_day",

  // DELIVERY METHOD
  [TRANSLATION_KEY.MAIL]: "mail",
  [TRANSLATION_KEY.FAX]: "fax",
  [TRANSLATION_KEY.BRANCH_MAMAGER_MAIL]: "branch_manager_mail",
  [TRANSLATION_KEY.UNNECESSARY]: "unnecessary",
  [TRANSLATION_KEY.POSTAL_MAIL]: "postal_mail",
  [TRANSLATION_KEY.WEB_SETTLEMENT]: "web_settlement",

  // CALCULATION METHOD
  [TRANSLATION_KEY.SEXAGESIMAL]: "sexagesimal",
  [TRANSLATION_KEY.DECIMAL]: "decimal",

  // OVERTIME PREMIUM METHOD
  [TRANSLATION_KEY.ACTUAL_WORKING_HOURS_ABOVE_X]: "actual_working_hours_above",
  [TRANSLATION_KEY.AFTER_REGULAR_WORKING_HOURS]: "after_regular_working_hours",

  // HOLIDAY PREMIUM METHOD
  [TRANSLATION_KEY.ABOVE_XHOURS]: "above",
  [TRANSLATION_KEY.SATURDAY_125_SUNDAY_135_HOLIDAY_125]:
    "satuday_125_sunday_135_holiday_125",
  [TRANSLATION_KEY.SATURDAY_125_SUNDAY_135]: "satuday_125_sunday_135",
  [TRANSLATION_KEY.SIXTH_DAY_125_7TH_DAY_135]: "6th_day_125_7th_day_135",

  // ONLINE PAYMENT PLATFORM
  [TRANSLATION_KEY.ESTAFFING]: "estaffing",
  [TRANSLATION_KEY.GOODJOB]: "goodjob",

  // ONLINE PAYMENT PRICING
  [TRANSLATION_KEY.ONLINE_PAYMENT_PRICING_FREE]: "free",
  [TRANSLATION_KEY.ONLINE_PAYMENT_PRICING_PAID]: "paid",

  // CLIENT TIME CARD TYPE
  [TRANSLATION_KEY.CLIENT_TIME_CARD_TYPE_HOTSTAFF]: "hotstaffs_time_card",

  //DISPATCH TYPE
  [TRANSLATION_KEY.REGISTRATION_BASED]: "registration_based",
  [TRANSLATION_KEY.PERMANENT_EMPLOYEE]: "permanent_employee",
  [TRANSLATION_KEY.TEMP_TO_PERM]: "temp_to_perm",
  [TRANSLATION_KEY.SHORT]: "short_term ",
  [TRANSLATION_KEY.HIGHLY_SKILLED_PROFESSIONAL]: "highly_skilled_professional",

  // EMPLOYMENT TRAINING
  [TRANSLATION_KEY.NEW_EMPLOYEE_TRAINING]: "new_employee_training",
  [TRANSLATION_KEY.SAFETY_AND_HEALTH_EDUCATION]: "safety_and_health_education",
  [TRANSLATION_KEY.OJT]: "ojt",

  // USABILITY
  [TRANSLATION_KEY.USABLE]: "usable",
  [TRANSLATION_KEY.UNUSABLE]: "unusable",

  // FACILITY_USABLE
  [TRANSLATION_KEY.ANYTIME]: "anytime",
  [TRANSLATION_KEY.SET_SPECIFIC_HOURS]: "set_specific_hours",
  [TRANSLATION_KEY.FACILITY_UNUSABLE]: "facility_unusable",

  // FACILITY
  [TRANSLATION_KEY.FACILITY_UNIFORM]: "facility.uniform",
  [TRANSLATION_KEY.FACILITY_CAFETERIA]: "facility.cafeteria",
  [TRANSLATION_KEY.FACILITY_BREAK_ROOM]: "facility.break_room",
  [TRANSLATION_KEY.FACILITY_CHANGING_ROOM]: "facility.changing_room",
  [TRANSLATION_KEY.FACILITY_LOCKER]: "facility.locker",
  [TRANSLATION_KEY.FACILITY_PARKING_LOT]: "facility.parking_lot",
  [TRANSLATION_KEY.FACILITY_HOSPITAL]: "facility.hospital",
  [TRANSLATION_KEY.FACILITY_CLINIC]: "facility.clinic",
  [TRANSLATION_KEY.FACILITY_BATHHOUSE]: "facility.bathhouse",
  [TRANSLATION_KEY.FACILITY_SHOP]: "facility.shop",
  [TRANSLATION_KEY.FACILITY_BARBER_SHOP]: "facility.barber_shop",
  [TRANSLATION_KEY.FACILITY_NURSERY]: "facility.nursery",
  [TRANSLATION_KEY.FACILITY_LIBRARY]: "facility.library",
  [TRANSLATION_KEY.FACILITY_AUDITORIUM]: "facility.auditorium",
  [TRANSLATION_KEY.FACILITY_RECREATION_ROOM]: "facility.recreation_room",
  [TRANSLATION_KEY.FACILITY_SPORTS_GROUND]: "facility.sports_ground",
  [TRANSLATION_KEY.FACILITY_GYMNASIUM]: "facility.gymnasium",
  [TRANSLATION_KEY.FACILITY_RECUPERATION_FACILITY]:
    "facility.recuperation_facility",
  [TRANSLATION_KEY.FACILITY_RECREATION_FACILITY]:
    "facility.recreation_facility",

  // FACILITY AVAILABILITY
  [TRANSLATION_KEY.FACILITY_AVAILABLE]: "facilities_available",
  [TRANSLATION_KEY.NO_FACILITY_AVAILABLE]: "no_facilities_available",

  // AIR CONDITIONING
  [TRANSLATION_KEY.AIR_CONDITIONING_FULL_AIR_CONDITIONING]:
    "full_air_conditioning",
  [TRANSLATION_KEY.AIR_CONDITIONING_SPOT_AIR_CONDITIONING]:
    "spot_air_conditioning",
  [TRANSLATION_KEY.AIR_CONDITIONING_NONE]: "none",
  [TRANSLATION_KEY.AIR_CONDITIONING_OUTDOORS]: "outdoors",

  // JOB LISTING EMPLOYMENT TYPE
  [TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH]:
    "job_listing.employment_type.dispatch",
  [TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_DISPATCH_PART_TIME]:
    "job_listing.employment_type.dispatch_part_time",
  [TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_TEMP_TO_PERM_PLACEMENT]:
    "job_listing.employment_type.temp_to_perm_placement",
  [TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FULL_TIME_EMPLOYEE]:
    "job_listing.employment_type.employment_placement_full_time_employee",
  [TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_EMPLOYMENT_PLACEMENT_FIXED_TERM_EMPLOYEE]:
    "job_listing.employment_type.employment_placement_fixed_term_employee",
  [TRANSLATION_KEY.JOB_LISTING_EMPLOYMENT_TYPE_FULL_TIME_EMPLOYEE_INCLUDING_PART_TIME]:
    "job_listing.employment_type.full_time_employee_including_part_time",

  // JOB TYPE ID
  [TRANSLATION_KEY.JOB_TYPE_ID_EMPLOYMENT_SECURITY_OPERATIONS_STATISTICS]:
    "job_type_id.employment_security_operations_statistics",
  [TRANSLATION_KEY.JOB_TYPE_ID_BASIC_WAGE_STRUCTURE_STATISTICS]:
    "job_type_id.basic_wage_structure_statistics",

  // WORKING ON HOLIDAY
  [TRANSLATION_KEY.WORKING_ON_HOLIDAY_MONTHLY_AVERAGE]: "monthly_average",
  [TRANSLATION_KEY.WORKING_ON_HOLIDAY_YEARLY_AVERAGE]: "yearly_average",

  // WORKING OVERTIME
  [TRANSLATION_KEY.WORKING_OVERTIME_DAILY_AVERAGE]: "daily_average",

  // JOB LISTING DURATION
  [TRANSLATION_KEY.JOB_LISTING_DURATION_TYPE_LONG_TERM]:
    "preferred_employment_duration.long_term",
  [TRANSLATION_KEY.JOB_LISTING_DURATION_TYPE_SHORT_TERM]:
    "preferred_employment_duration.short_term",

  // JOB LISTING HOLIDAY
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_OFF]:
    "job_listing_holiday_preference.weekends_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_WEEKENDS_OFF]:
    "job_listing_holiday_preference.full_weekends_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF]:
    "job_listing_holiday_preference.weekends_and_public_holidays_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_WEEKENDS_AND_PUBLIC_HOLIDAYS_OFF]:
    "job_listing_holiday_preference.full_weekends_and_public_holidays_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED]:
    "job_listing_holiday_preference.two_days_off_per_week_shift_based",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_FULL_TWO_DAYS_OFF_PER_WEEK_SHIFT_BASED]:
    "job_listing_holiday_preference.full_two_days_off_per_week_shift_based",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_DAYS_ON_DAYS_OFF]:
    "job_listing_holiday_preference.days_on_days_off",
  [TRANSLATION_KEY.JOB_LISTING_HOLIDAY_WEEKDAYS_OFF]:
    "job_listing_holiday_preference.weekdays_off",

  // JOB LISTING ALLOWANCE
  [TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_PERFECT_ATTENDANCE_ALLOWANCE]:
    "perfect_attendance_allowance",
  [TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_DILIGENCE_ALLOWANCE]:
    "diligence_allowance",
  [TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_MEAL_ALLOWANCE]: "meal_allowance",
  [TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_HOUSING_ALLOWANCE]:
    "housing_allowance",
  [TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_FAMILY_ALLOWANCE]: "family_allowance",
  [TRANSLATION_KEY.JOB_LISTING_ALLOWANCE_YEAR_END_AND_NEW_YEAR_ALLOWANCE]:
    "year_end_and_new_year_allowance",

  //OFFICE WORKER QUALIFICATION
  [TRANSLATION_KEY.DISPATCHING_AGENCY_MANAGER]: "dispatching_gency_manager",
  [TRANSLATION_KEY.EMPLOYMENT_PLACEMENT_MANAGER]:
    "employment_placement_manager",
  [TRANSLATION_KEY.MANUFACTURING_SPECIALIZED_DISPATCHING_AGENCY_MANAGER]:
    "manufacturing_specialized_dispatching_agency_manager",
  [TRANSLATION_KEY.SECOND_CLASS_HEALTH_SUPERVISOR]:
    "second_class_health_supervisor",

  // GENDER
  [TRANSLATION_KEY.GENDER_MALE]: "male",
  [TRANSLATION_KEY.GENDER_FEMALE]: "female",
  [TRANSLATION_KEY.GENDER_MALE_FEMALE]: "male_and_female",

  // JOB LISTING CERTIFICATIONS
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_DRIVERS_LICENSE]:
    "job_listing.certification.drivers_license",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_LARGE_VEHICLE_DRIVERS_LICENSE]:
    "job_listing.certification.large_vehicle_drivers_license",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_FORKLIFT_CERTIFICATION]:
    "job_listing.certification.forklift_certification",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_SLINGING_CERTIFICATION]:
    "job_listing.certification.slinging_certification",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_CRANE_CERTIFICATION]:
    "job_listing.certification.crane_certification",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_3]:
    "job_listing.certification.bookkeeping_level_3",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_BOOKKEEPING_LEVEL_2]:
    "job_listing.certification.bookkeeping_level_2",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_NURSERY_TEACHER_LICENSE]:
    "job_listing.certification.nursery_teacher_license",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_KINDERGARTEN_TEACHER_LICENSE]:
    "job_listing.certification.kindergarten_teacher_license",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_COOK_LICENSE]:
    "job_listing.certification.cook_license",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_NUTRITIONIST_LICENSE]:
    "job_listing.certification.nutritionist_license",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_HELPER_LEVEL_2]:
    "job_listing.certification.helper_level_2",
  [TRANSLATION_KEY.JOB_LISTING_CERTIFICATIONS_CERTIFIED_CARE_WORKER_BEGINNER_TRAINING]:
    "job_listing.certification.certified_care_worker_beginner_training",

  // JOB LISTING EXPERIENCE
  [TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_MANUFACTURING_EXPERIENCE]:
    "job_listing.certification.manufacturing_experience",
  [TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_INSPECTION_EXPERIENCE]:
    "job_listing.certification.inspection_experience",
  [TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_FORKLIFT_OPERATION_EXPERIENCE]:
    "job_listing.certification.forklift_operation_experience",
  [TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_MACHINE_OPERATION_EXPERIENCE]:
    "job_listing.certification.machine_operation_experience",
  [TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_FOOD_MANUFACTURING_EXPERIENCE]:
    "job_listing.certification.food_manufacturing_experience",
  [TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_CLERICAL_WORK_EXPERIENCE]:
    "job_listing.certification.clerical_work_experience",
  [TRANSLATION_KEY.JOB_LISTING_EXPERIENCE_TELEPHONE_HANDLING_EXPERIENCE]:
    "job_listing.certification.telephone_handling_experience",

  [TRANSLATION_KEY.PRODUCTION]: "production",
  [TRANSLATION_KEY.WHITE_COLLAR]: "white_collar",

  [TRANSLATION_KEY.DAILY]: "daily",
  [TRANSLATION_KEY.HOURLY]: "hourly",

  // UNIFORM
  [TRANSLATION_KEY.UNIFORM_PROVIDED]: "uniform_provided",
  [TRANSLATION_KEY.PREPARE_OWN]: "prepare_own",
  [TRANSLATION_KEY.NONE]: "none",

  // MID SHIFT BREAK METHOD
  [TRANSLATION_KEY.GOING_PUT_PERMITTED]: "going_out_permitted",
  [TRANSLATION_KEY.STAYING_IN_CAR_PERMITTED]: "staying_in_car_permitted",
  [TRANSLATION_KEY.TEMPORARY_RETURN_HOME_PERMITTED]:
    "temporary_return_home_permitted",

  // GROOMING
  [TRANSLATION_KEY.BLACK_TO_DARK_BROWN]: "black_to_dark_brown",
  [TRANSLATION_KEY.BLACK]: "black",
  [TRANSLATION_KEY.SIMPLE_NAILS_OK]: "simple_nails_ok",
  [TRANSLATION_KEY.NOT_ALLOWED]: "not_allowed",
  [TRANSLATION_KEY.OK_IF_HIDDEN]: "ok_if_hidden",
  [TRANSLATION_KEY.NO_TATTOOS]: "no_tattoos",
  [TRANSLATION_KEY.OK_IF_KEPT_CLEAN]: "ok_if_kept_clean",
  [TRANSLATION_KEY.NO_BREADS]: "no_beards",

  // EMPLOYMENT QUALIFICATION
  [TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_DRIVERS_LICENSE]:
    "employment_qualification.drivers_license",
  [TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_CLASS_2_HEALTH_SUPERVISOR]:
    "employment_qualification.class_2_health_supervisor",
  [TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_DISPATCHING_AGENCY_MANAGER]:
    "employment_qualification.dispatching_agency_manager",
  [TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_FEE_CHARGING_EMPLOYMENT_PLACEMENT_MANAGER]:
    "employment_qualification.fee_charging_employment_placement_manager",
  [TRANSLATION_KEY.EMPLOYMENT_QUALIFICATION_CAREER_CONSULTANT]:
    "employment_qualification.career_consultant",

  // EMPLOYMENT POST
  [TRANSLATION_KEY.EMPLOYMENT_POST_GM]: "employment_post.gm",
  [TRANSLATION_KEY.EMPLOYMENT_POST_AM]: "employment_post.am",
  [TRANSLATION_KEY.EMPLOYMENT_POST_BRANCH_MANAGER]:
    "employment_post.branch_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_EXECUTIVE_GENERAL_MANAGER]:
    "employment_post.executive_general_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_DEPARTMENT_MANAGER]:
    "employment_post.department_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_DEPUTY_GENERAL_SECTION_MANAGER]:
    "employment_post.deputy_general_section_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_DEPUTY_GENERAL_MANAGER]:
    "employment_post.deputy_general_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_GENERAL_SECTION_MANAGER]:
    "employment_post.general_section_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_SECTION_MANAGER]:
    "employment_post.section_manager",
  [TRANSLATION_KEY.EMPLOYMENT_POST_ASSISTANT]: "employment_post.assistant",
  [TRANSLATION_KEY.EMPLOYMENT_POST_STAFF]: "employment_post.staff",
  [TRANSLATION_KEY.EMPLOYMENT_POST_SECTION_CHIEF]:
    "employment_post.section_chief",
  [TRANSLATION_KEY.EMPLOYMENT_POST_SUPERVISOR]: "employment_post.supervisor",

  // AFFILIATED BRANCH
  [TRANSLATION_KEY.AFFILIATED_BRANCH_BRANCH]: "affiliated_branch.branch",
  [TRANSLATION_KEY.AFFILIATED_BRANCH_MAIN]: "affiliated_branch.main",
  [TRANSLATION_KEY.AFFILIATED_BRANCH_HEADQUARTER]:
    "affiliated_branch.headquarter",

  // EMPLOYMENT BRANCH TYPE
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SALES_DEPARTMENT]:
    "employment_branch_type.sales_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_DEPARTMENT]:
    "employment_branch_type.administration_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CLERICAL]:
    "employment_branch_type.clerical",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_COORDINATOR]:
    "employment_branch_type.coordinator",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ATTENDANT]:
    "employment_branch_type.attendant",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_IT_DEPARTMENT]:
    "employment_branch_type.it_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_PUBLIC_RELATIONS_DEPARTMENT]:
    "employment_branch_type.public_relations_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_MARKETING_DEPARTMENT]:
    "employment_branch_type.marketing_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_CONTROL_DEPARTMENT]:
    "employment_branch_type.control_department",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_GENERAL_AFFAIRS_SECTION]:
    "employment_branch_type.general_affairs_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_ADMINISTRATION_SECTION]:
    "employment_branch_type.administration_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_EDUCATION_SECTION]:
    "employment_branch_type.education_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_HUMAN_RESOURCES_SECTION]:
    "employment_branch_type.human_resources_section",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_ONE]:
    "employment_branch_type.section_one",
  [TRANSLATION_KEY.EMPLOYMENT_BRANCH_TYPE_SECTION_TWO]:
    "employment_branch_type.section_two",

  // CLIENT POC
  [TRANSLATION_KEY.ORGANIZATION_CHIEF]: "organization_chief",
  [TRANSLATION_KEY.COMMANDER]: "commander",
  [TRANSLATION_KEY.CORPORATION_PIC]: "corporation_pic",
  [TRANSLATION_KEY.CORPORATION_COMPLAINT_OFFICER]: "corporation_complaint",
  [TRANSLATION_KEY.HOTSTAFF_PIC]: "hotstaff_person_in_charge",
  [TRANSLATION_KEY.HOTSTAFF_COMPLAINT_OFFICER]: "hotstaff_complaint_officer",

  // JOB LISTING CATEGORY
  [TRANSLATION_KEY.JOB_CATEGORY_MANUFACTURING_LIGHT_WORK]:
    "job.category.manufacturing_light_work",
  [TRANSLATION_KEY.JOB_CATEGORY_FOOD_MANUFACTURING]:
    "job.category.food_manufacturing",
  [TRANSLATION_KEY.JOB_CATEGORY_LOGISTICS_WAREHOUSE_MANAGEMENT]:
    "job.category.logistics_warehouse_management",
  [TRANSLATION_KEY.JOB_CATEGORY_CLERICAL_OFFICE_WORK]:
    "job.category.clerical_office_work",
  [TRANSLATION_KEY.JOB_CATEGORY_MEDICAL_NURSING_CARE_WELFARE]:
    "job.category.medical_nursing_care_welfare",
  [TRANSLATION_KEY.JOB_CATEGORY_SALES_RETAIL_SERVICE_INDUSTRY]:
    "job.category.sales_retail_service_industry",
  [TRANSLATION_KEY.JOB_CATEGORY_FOOD_SERVICE_HOSPITALITY]:
    "job.category.food_service_hospitality",
  [TRANSLATION_KEY.JOB_CATEGORY_CONVENIENCE_STORE_SUPERMARKET]:
    "job.category.convenience_store_supermarket",
  [TRANSLATION_KEY.JOB_CATEGORY_IT_CREATIVE_TECHNICAL]:
    "job.category.it_creative_technical",

  // DESIRED NATIONALITY
  [TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_ONLY]: "japanese_only",
  [TRANSLATION_KEY.DESIRED_NATIONALITY_FOREIGN_WORKERS_ONLY]:
    "foreign_workers_only",
  [TRANSLATION_KEY.DESIRED_NATIONALITY_JAPANSESE_AND_FOREIGN_WORKERS]:
    "japanese_and_foreign_workers",

  // USABILITY
  [TRANSLATION_KEY.USABILITY_REQUIRED]: "required",
  [TRANSLATION_KEY.USABILITY_NEGOTIABLE]: "negotiable",

  // NEAREST_STATION_MODE_OPTIONS
  [TRANSLATION_KEY.NEAREST_STATION_MODE_CAR]:
    "module.organization.add.nearest_station.mode.car",
  [TRANSLATION_KEY.NEAREST_STATION_MODE_WALKING]:
    "module.organization.add.nearest_station.mode.walking",
  [TRANSLATION_KEY.NEAREST_STATION_MODE_BUS]:
    "module.organization.add.nearest_station.mode.bus",
  [TRANSLATION_KEY.NEAREST_STATION_MODE_TRAIN]:
    "module.organization.add.nearest_station.mode.train",

  // KANBAN TITLE
  [TRANSLATION_KEY.KANBAN_TITLE_CONFIRM_STAFF_NEEDS]:
    "kanban_title_confirm_staff_needs",
  [TRANSLATION_KEY.KANBAN_TITLE_ADJUSTING_INTERVIEW_DATE]:
    "kanban_title_adjusting_interview_date",
  [TRANSLATION_KEY.KANBAN_TITLE_CONFIRMED_INTERVIEW_DATE]:
    "kanban_title_confirmed_interview_date",
  [TRANSLATION_KEY.KANBAN_TITLE_STAFF_AWAITING_RECOMMENDATIONS]:
    "kanban_title_staff_awaiting_recommendations",

  // KANBAN
  [TRANSLATION_KEY.KANBAN_FIELD_SALES]: "kanban_field_sales",
  [TRANSLATION_KEY.KANBAN_INSIDE_SALES]: "kanban_inside_sales",
  [TRANSLATION_KEY.KANBAN_TITLE_SALES_PREPARATION]:
    "kanban_title_sales_preparation",
  [TRANSLATION_KEY.KANBAN_TITLE_CREATE_SALES_MATERIAL]:
    "kanban_title_create_sales_material",
  [TRANSLATION_KEY.KANBAN_TITLE_SALES_IN_PROGRESS]:
    "kanban_title_sales_in_progress",
  [TRANSLATION_KEY.KANBAN_TITLE_NEGOTIATE_ORDER_DETAILS]:
    "kanban_title_negotiate_order_details",
  [TRANSLATION_KEY.KANBAN_TITLE_TAKING_ORDERS]: "kanban_title_taking_orders",
  [TRANSLATION_KEY.KANBAN_TITLE_ASSEMBLE_TEAM]: "kanban_title_assemble_team",
  [TRANSLATION_KEY.KANBAN_TITLE_ADJUSTING_WORKPLACE_TOUR]:
    "kanban_title_adjusting_workplace_tour",
  [TRANSLATION_KEY.KANBAN_TITLE_WORKPLACE_TOUR_IN_PROGRESS]:
    "kanban_title_workplace_tour_in_progress",
  [TRANSLATION_KEY.KANBAN_TITLE_AWAITING_CLIENT_RESPONSE]:
    "kanban_title_awaiting_client_response",
  [TRANSLATION_KEY.KANBAN_TITLE_CONFIRM_TERMS]: "kanban_title_confirm_terms",
  [TRANSLATION_KEY.KANBAN_TITLE_PROCESSING_LEDGER_STATEMENTS]:
    "kanban_title_processing_ledger_statements",
  [TRANSLATION_KEY.KANBAN_TITLE_CLIENT_CONTRACT_CLOSING]:
    "kanban_title_client_contract_closing",
  [TRANSLATION_KEY.KANBAN_TITLE_FIRST_DAY_OF_DISPATCH_WORK]:
    "kanban_ticket_first_day_of_dispatch_work",
  [TRANSLATION_KEY.KANBAN_TITLE_PROCESSING_EMPLOYMENT_INSURANCE]:
    "kanban_ticket_processing_employment_insurance",
  [TRANSLATION_KEY.KANBAN_TITLE_PROCESSING_SOCIAL_INSURANCE]:
    "kanban_ticket_processing_social_insurance",
  [TRANSLATION_KEY.KANBAN_TITLE_STAFF_EMPLOYED]: "kanban_ticket_staff_employed",

  // STAFF STATUS
  [TRANSLATION_KEY.STAFF_STATUS_WORKING_STAFF]: "working_staff",
  [TRANSLATION_KEY.STAFF_STATUS_POOL_STAFF]: "pool_staff",
  [TRANSLATION_KEY.STAFF_STATUS_TEMPORARY_STAFF]: "temporary_staff",
};
